export const SALES_SUBSCRIPTION = 'SALES_SUBSCRIPTION';
export const ACTIVE_ENROLLMENTS = 'ACTIVE_ENROLLMENTS';
export const ACTIVE_AGENT_ENROLLMENTS = 'ACTIVE_AGENT_ENROLLMENTS';
export const MISSING_EMAIL = 'MISSING_EMAIL';
export const INVALID_EMAIL = 'INVALID_EMAIL';